import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function HomeArticles() {
  return (
    <section className="py-20 bg-[#f0f6ff]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-700 text-xs font-semibold px-4 py-2 rounded-full mb-4">
              <i className="ri-article-line"></i>
              Conteúdo Educacional
            </div>
            <h2 className="text-3xl md:text-4xl font-extrabold text-[#0d1f3c]">
              Artigos Gerais de Trading
            </h2>
          </div>
          <Link
            to="/artigos"
            className="shrink-0 inline-flex items-center gap-2 border border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white font-semibold px-6 py-3 rounded-full text-sm transition-all cursor-pointer whitespace-nowrap"
          >
            Ver todos
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.slice(0, 6).map((article) => (
            <Link
              key={article.id}
              to={`/artigos/${article.id}`}
              className="group bg-white rounded-2xl overflow-hidden border border-blue-100 hover:border-blue-300 transition-all cursor-pointer"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-3">
                  <span className="flex items-center gap-1.5 bg-blue-50 text-blue-700 text-xs font-semibold px-3 py-1 rounded-full">
                    <i className={`${article.categoryIcon} text-xs`}></i>
                    {article.category}
                  </span>
                  <span className="text-slate-400 text-xs">{article.readTime} de leitura</span>
                </div>
                <h3 className="font-bold text-[#0d1f3c] text-base leading-snug mb-2 group-hover:text-blue-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-slate-500 text-sm leading-relaxed line-clamp-2">{article.excerpt}</p>
                <div className="flex items-center gap-2 mt-4 pt-4 border-t border-slate-100">
                  <div className="w-7 h-7 rounded-full bg-blue-100 flex items-center justify-center">
                    <i className="ri-user-line text-blue-600 text-xs"></i>
                  </div>
                  <div>
                    <div className="text-xs font-semibold text-slate-700">{article.author}</div>
                    <div className="text-xs text-slate-400">{article.date}</div>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
